<template>
  <td>
    <span>{{startText}} </span>
    <span class="type_ib"> ~ {{endText}}</span>
  </td>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "DATE"
    },
    start: [String, Date],
    end: [String, Date]
  },
  computed: {
    isTime() {
      return this.type === "TIME";
    },
    startText() {
      return this.$utils[`${this.type.toLowerCase()}Text`](this.start);
    },
    endText() {
      return this.$utils[`${this.type.toLowerCase()}Text`](this.end);
    }
  }
};
</script>

<style>
</style>
